<div class="margin-all-area">
    <div class="tag-management-panel">
        <div class="wraper-main-section">
            <div class="global-card-section">
                <div class="global-header-section">
                    <div class="svg-icon-panel">Option</div>
                    <div class="header-button-panel">
                        <div class="button-wrapper" *ngIf="isEditMode">
                            <button *ngIf="isViewMode" class="icon-btn" type="button" matTooltip="Edit" (click)="isViewMode = false">
                                <i class="fa fa-pencil-alt" aria-hidden="true"></i>
                                <span class="btn-text">Edit</span>
                            </button>
                            <button *ngIf="!isViewMode" class="icon-btn" type="button" matTooltip="Save" (click)="onSaveOption()">
                                <i class="fa fa-save" aria-hidden="true"></i>
                                <span class="btn-text">Save</span>
                            </button>
                            <button class="icon-btn" type="button" matTooltip="Cancel" (click)="cancel();isViewMode = true">
                                <i class="fa fa-arrow-left" aria-hidden="true"></i>
                                <span class="btn-text">Cancel</span>
                            </button>

                        </div>
                    </div>
                </div>
                <div *ngIf="!isConfirmed && message" [ngClass]="'alert alert-panel' + messageType" [innerHTML]="message"></div>
                <div *ngIf="isConfirmed" [ngClass]="'company-2d-alert' + messageType" [innerHTML]="message"></div>
                <div class="global-body-section">
                    <form [formGroup]="vtOptionForm">
                        <div class="align-top-style">
                            <div class="wraper-body-panel">
                                <div class="wraper-body-left">
                                    <div class="cards-body-section">
                                        <div class="flex-width-panel">
                                            <div class="cards-colunm-left">
                                                <span class="control-label">Digit</span>
                                            </div>
                                            <div class="cards-colunm-right">
                                                <div class="w-100">
                                                    <span *ngIf="isViewMode">{{selectedOption?.digit}}</span>
                                                    <input *ngIf="!isViewMode" type="text" inputmode="numeric" class="form-control" pattern="[0-9]" step="1" id="digit" maxlength="1" name="digit" formControlName="digit" />
                                                    <div *ngIf="vtOptionForm.get('digit')?.touched && vtOptionForm.get('digit')?.invalid">
                                                        <small class="text-danger" *ngIf="vtOptionForm.get('digit')?.errors?.['required']"> Please enter a digit. </small>
                                                        <small class="text-danger" *ngIf="vtOptionForm.get('digit')?.errors?.['pattern']"> Please enter a number from 0 through 9.</small>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="cards-body-section">
                                        <div class="flex-width-panel">
                                            <div class="cards-colunm-left">
                                                <span class="control-label">Name</span>
                                            </div>
                                            <div class="cards-colunm-right">
                                                <div class="w-100">
                                                    <span *ngIf="isViewMode">{{selectedOption?.name}}</span>
                                                    <input *ngIf="!isViewMode" type="text" class="form-control" id="name" name="name" formControlName="name" />
                                                    <div *ngIf="vtOptionForm.get('name')?.touched && vtOptionForm.get('name')?.invalid">
                                                        <small class="text-danger" *ngIf="vtOptionForm.get('name')?.errors?.['required']"> Please enter a name. </small>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>


                                    <div class="cards-body-section">
                                        <div class="flex-width-panel">
                                            <div class="cards-colunm-left">
                                                <span class="control-label" for=""> Action Type</span>
                                            </div>
                                            <div class="cards-colunm-right">
                                                <div class="w-100">
                                                    <span *ngIf="isViewMode">{{selectedOption?.typeDisplay}}</span>
                                                    <select *ngIf="!isViewMode" class="form-control" formControlName="optionType">
                                                        <option [ngValue]="0">Transfer to Phone Number</option>
                                                        <!--<option *ngFor="let item of vrDDList" [value]="item.id">{{item.text}}</option>-->
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="cards-body-section">
                                        <div class="flex-width-panel">
                                            <div class="cards-colunm-left">
                                                <span class="control-label" for=""> Phone number</span>
                                            </div>
                                            <div class="cards-colunm-right">
                                                <div class="w-100">
                                                    <span *ngIf="isViewMode">{{selectedOption?.valueDisplay}}</span>
                                                    <input *ngIf="!isViewMode"
                                                           type="text"
                                                           class="form-control"
                                                           formControlName="optionValue"
                                                           inputmode="numeric"
                                                           (keypress)="numbersOnly($event)" />
                                                    <div *ngIf="vtOptionForm.get('optionValue')?.touched && vtOptionForm.get('optionValue')?.invalid">
                                                        <small class="text-danger" *ngIf="vtOptionForm.get('optionValue')?.errors?.['required']"> Please enter a phone number. </small>
                                                        <small class="text-danger"
                                                               *ngIf="vtOptionForm.get('optionValue')?.errors?.['pattern']">
                                                            Only numbers are allowed.
                                                        </small>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="cards-body-section">
                                        <div class="flex-width-panel">
                                            <div class="cards-colunm-left">
                                                <span class="control-label" for="Record Call">
                                                    Announce Script<br />After Transfer
                                                </span>
                                            </div>
                                            <div class="cards-colunm-right">
                                                <div class="w-100">
                                                    <span *ngIf="isViewMode">{{selectedOption?.announceScript}}</span>
                                                    <input *ngIf="!isViewMode" type="text" class="form-control" name="announceScript" formControlName="announceScript" />

                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="cards-body-section">
                                        <div class="flex-width-panel">
                                            <div class="cards-colunm-left">
                                                <span class="control-label" for=""> </span>
                                            </div>

                                            <div class="cards-colunm-right" *ngIf="isEditMode">
                                                <div class="w-100" *ngIf="!isViewMode; else viewButtons">
                                                    <button class="btn btn-primary" *ngIf="!isConfirmed" (click)="onSaveOption()">Save</button>
                                                    <button class="btn btn-cancel" (click)="cancel(); isViewMode = true; ">Cancel</button>
                                                    <button class="btn btn-danger" *ngIf="!isConfirmed && selectedOption?.voiceTreeOptionID > 0" (click)="deleteConfirm();isConfirmed = true;isViewMode = true; ">Delete</button>
                                                </div>
                                                <ng-template #viewButtons>
                                                    <div class="w-100">
                                                        <button class="btn btn-warning" *ngIf="isConfirmed" (click)="vtOptionDelete()">Confirm</button>
                                                        <button class="btn btn-cancel" *ngIf="isConfirmed" (click)="cancel(); isViewMode = true;">Cancel</button>
                                                    </div>
                                                </ng-template>
                                            </div>
                                        </div>
                                    </div>


                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>
